import { pageState } from '../state/page'
import {
  abTestState,
  tagsListState,
  dynamicOptionsState,
  searchCriteriaState,
  dynamicFieldsState,
  visibleColumnsState,
  sendingPreviewState,
  recipientsDataTablePreviewState,
  progressState
} from '../state/abtest'

import { logAppError } from 'Helpers/logger'
import {
  addNewTag,
  getAllTags,
  fetchEmailEntitiesThatUseMessage,
  getABTestConfigByIdAction,
  getMessageDetailsAction,
  saveABTestConfigAction,
  generateThumbnailAction,
  fastCheck,
  getAccountSendingLimits,
  fetchSenderInfo,
  getRecipientTestsDefault,
  getDynamicFields,
  getUserColumns,
  putBeListSenderInfo,
  getGroupsDetails,
  getFilters,
  simulatePreview,
  searchForRecipients,
  updateUserColumns,
  notifyQueueing,
  startProcessAbTestAction,
  getBeABTestGetGlobalStatus,
  getBeABTestGetAsycQueueConfId,
  checkScheduleAbTestByIdAction,
  scheduleAbTestByIdAction
} from '../actions/actions'
import getIntl from 'Helpers/intl'
import { modalEmailMessagesState } from 'Hooks/useModalEmailMessages/useModalEmailMessages'
import {
  modalCheckupState,
  modalColumnsManagementState,
  modalUsedMessageState
} from 'Pages/AbTestWizard/recoil/state/modals'
import {
  ABTEST_STATUS_ERROR,
  ABTEST_STATUS_SCHEDULING,
  ABTEST_STATUS_CONFIGURATION,
  ABTEST_STATUS_PRE_ENQUEUING,
  ABTEST_STATUS_ENQUEUING,
  ABTEST_STATUS_POST_ENQUEUING,
  ABTEST_STATUS_WAITING_FOR_SENDING_OF_TEST_MESSAGES,
  ABTEST_STATUS_SCHEDULED,
  ABTEST_STATUS_SUGGESTED_TEST_DATE,
  ABTEST_STATUS_SUGGEST_BOTH_DATE,
  ABTEST_STATUS_SUGGESTED_WINNER_DATE
} from 'Api/beABTestApi'
import { STORE_KEY_ID_LIST } from 'mailup-react-helpers'
import { storeGet } from 'mailup-react-helpers'
import {
  TOAST_VARIANT_SUCCESS,
  TOAST_VARIANT_WARNING,
  toastShow,
  TOAST_VARIANT_ERROR,
  PROGRESSBAR_VARIANT_DEFAULT,
  PROGRESSBAR_VARIANT_SUCCESS,
  PROGRESSBAR_VARIANT_ERROR
} from 'mailup-web-components'
import {
  BEQUEUE_CONFIG_FILTER_COND_AND_NUM,
  BEQUEUE_CONFIG_FILTER_COND_OR_NUM,
  BEQUEUE_CONFIG_STATE_COMPLETED,
  BEQUEUE_CONFIG_STATE_FAILED,
  BEQUEUE_CONFIG_STATE_RUNNING
} from 'Api/beQueueApi'
import {
  MATCH_FILTER_CONDITION_ALL,
  ENTITY_TYPE_TRIGGER,
  ENTITY_TYPE_AUTOMATION_WORKFLOW
} from 'Constants/'
import moment from 'moment-timezone'
import { zones } from 'Helpers/dates'
import { contentScheduledState } from 'Components/ContentScheduled/recoil/state'
import { async } from 'regenerator-runtime'

export const changeWizardStepCallback = ({
  set,
  snapshot
}) => async nextStep => {
  const { wizardStep: currentStep } = await snapshot.getPromise(pageState)
  if (currentStep !== 4) {
    set(pageState, prev => ({ ...prev, wizardStep: nextStep }))
  }
}

export const resetCallback = ({ set, reset }) => async id => {
  reset(modalCheckupState)
  reset(modalUsedMessageState)
  reset(pageState)
  reset(abTestState)
  reset(tagsListState)
}

export const initCallback = ({ set }) => async id => {
  set(pageState, prev => ({ ...prev, loading: true, loaded: false }))
  const idABTest = parseInt(id, 0)
  try {
    const [tagsList, abTestData] = await Promise.all([
      getAllTags(),
      idABTest > 0 ? getABTestConfigByIdAction(idABTest) : null
    ])

    if (idABTest > 0) {
      let idAsycQueueConfId = null

      if (abTestData.Info.Stato >= ABTEST_STATUS_SCHEDULING) {
        idAsycQueueConfId = getBeABTestGetAsycQueueConfId(idABTest)
      }

      set(abTestState, prev => ({
        ...prev,
        id: idABTest,
        stato: abTestData.Info.Stato,
        step1: {
          ...prev.step1,
          name: abTestData.Info.Nome,
          abTestMessages: abTestData.Messages.filter(
            f => f.TipoInvio === 1
          ).map(m => ({
            Id: m.IdMessaggio
          })),
          percTest: abTestData.Info.PercTest,
          tipoTest: abTestData.Info.TipoTest,
          criterio: abTestData.Info.Criterio,
          tags: abTestData.Tags
        },
        step4: {
          ...prev.step4,
          idAsyncQueueConfig: idAsycQueueConfId,
          step4IsDirty: true
        }
      }))

      abTestData.Messages.forEach(async m => {
        if (m.TipoInvio === 1) {
          const msgDett = await getMessageDetailsAction(m.IdMessaggio)

          set(abTestState, prev => ({
            ...prev,
            step1: {
              ...prev.step1,
              abTestMessages: prev.step1.abTestMessages.map(a =>
                a.Id === m.IdMessaggio
                  ? {
                      ...a,
                      TipoInvio: 1,
                      IdMessaggio: m.IdMessaggio,
                      Subject: msgDett.Subject,
                      Note: msgDett.Note,
                      HasThumbnail: msgDett.HasThumbnail,
                      LastUpdated: msgDett.LastUpdated
                    }
                  : a
              )
            }
          }))

          if (!msgDett.HasThumbnail) {
            const resp = await generateThumbnailAction(m.IdMessaggio)
            set(abTestState, prev => ({
              ...prev,
              step1: {
                ...prev.step1,
                abTestMessages: prev.step1.abTestMessages.map(a =>
                  a.Id === m.IdMessaggio
                    ? {
                        ...a,
                        HasThumbnail: resp
                      }
                    : a
                )
              }
            }))
          }
        }
      })
    }
    set(tagsListState, prev => ({ ...prev, tagsList: tagsList.Items }))

    set(pageState, prev => ({
      ...prev,

      wizardStep:
        !abTestData || abTestData.Info.Stato === ABTEST_STATUS_CONFIGURATION
          ? 1
          : 4,
      numberOfStepEnabled:
        !abTestData || abTestData.Info.Stato === ABTEST_STATUS_CONFIGURATION
          ? 1
          : 'only4'
    }))
  } catch (error) {
    logAppError({
      Component: 'ABTestWizard',
      Method: 'initCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(pageState, prev => ({ ...prev, loading: false, loaded: true }))
}

export const saveABTestConfigCallback = ({ set, snapshot }) => async (
  id,
  step,
  onSuccess
) => {
  set(pageState, prev => ({ ...prev, showLoader: true }))

  try {
    const { step1 } = await snapshot.getPromise(abTestState)

    const ret = await saveABTestConfigAction({
      Info: {
        ABTestID: id,
        Nome: step1.name,
        PercTest: step1.percTest,
        Criterio: step1.criterio,
        // TempoValutazione: 0,
        TipoTest: step1.percTest === 100 ? 'X' : step1.tipoTest,
        Stato:
          step === 1
            ? ABTEST_STATUS_CONFIGURATION
            : ABTEST_STATUS_CONFIGURATION,
        IdList: parseInt(storeGet(STORE_KEY_ID_LIST)),
        // TotalRecipients: 0,
        ErrorCode: '',
        // Deleted: false,
        // TestDateCTZScheduled: '2022-02-28T15:08:03.580Z',
        // WinnerIntervalSecondsScheduled: 0,
        // WinnerDateCTZScheduled: '2022-02-28T15:08:03.580Z',
        TimeZoneScheduled: ''
        // CreationDate: '2022-02-28T15:08:03.580Z',
        // LastModificationDate: '2022-02-28T15:08:03.580Z'
      },
      Messages: step1.abTestMessages,
      Tags: step1.tags
    })

    if (id === 0) {
      set(abTestState, prev => ({
        ...prev,
        id: ret.Info.ABTestID,
        stato: ABTEST_STATUS_CONFIGURATION
      }))
    }

    if (step === 1) {
      try {
        set(modalCheckupState, prev => ({
          ...prev,
          show: false,
          error: false
        }))

        const checkupArrayResp = await Promise.all(
          step1.abTestMessages.map(m => fastCheck(m.IdMessaggio))
        )

        // show modal if error
        if (checkupArrayResp && checkupArrayResp.find(f => f.blocking > 0)) {
          set(modalCheckupState, prev => ({
            ...prev,
            show: true,
            checkupArrayResp: checkupArrayResp.filter(f => f.blocking > 0)
          }))
          set(pageState, prev => ({ ...prev, showLoader: false }))
        } else if (onSuccess && typeof onSuccess === 'function') {
          set(pageState, prev => ({ ...prev, showLoader: false }))
          onSuccess()
        }
      } catch (error) {
        logAppError({
          Component: 'ABTestWizard',
          Method: 'fastCheck',
          appError: error
        })
        set(modalCheckupState, prev => ({
          ...prev,
          show: true,
          error: true
        }))
        set(pageState, prev => ({ ...prev, showLoader: false }))
      }
    } else {
      if (onSuccess && typeof onSuccess === 'function') {
        set(pageState, prev => ({ ...prev, showLoader: false }))
        onSuccess()
      }
    }
  } catch (error) {
    logAppError({
      Component: 'ABTestWizard',
      Method: 'saveABTestConfigCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
    set(pageState, prev => ({ ...prev, showLoader: false }))
  }
}

export const initAbTestSendingWizardCallback = ({ set }) => async () => {
  set(pageState, prev => ({ ...prev, showLoader: true, loadedStep2: false }))

  try {
    const [
      { TotalSend, TotalQueued, SendLimit, TrialRecepientLimit },
      senderInfo,
      testDefault,
      dynamicFields,
      userColumns
    ] = await Promise.all([
      getAccountSendingLimits(),
      fetchSenderInfo(),
      getRecipientTestsDefault(),
      getDynamicFields(),
      getUserColumns()
    ])

    const dynamicOptions = dynamicFields.map(e => {
      return {
        value: e.Id,
        label: `${e.Id} - ${e.Description}`
      }
    })

    set(abTestState, prev => ({
      ...prev,
      step2: {
        ...prev.step2,
        senderInfo: senderInfo,
        idTestDefault:
          testDefault && testDefault.Id ? testDefault.Id : undefined
      }
    }))

    set(dynamicOptionsState, dynamicOptions)
    set(dynamicFieldsState, dynamicFields)

    const safeUserColumns = userColumns.filter(column => {
      const dynamicFieldMatch = column.match(/Field(\d+)/)

      return dynamicFieldMatch
        ? dynamicFields.find(({ Id }) => Id === parseInt(dynamicFieldMatch[1]))
        : true
    })

    set(visibleColumnsState, safeUserColumns)

    // if (senderInfo.idAsyncQueueConfig) {
    //   if (
    //     [BEQUEUE_CONFIG_STATE_FAILED, BEQUEUE_CONFIG_STATE_RUNNING].includes(
    //       senderInfo.queueStatus
    //     )
    //   ) {
    //     set(pageState, prev => ({ ...prev, wizardStep: 3 }))
    //   } else if (senderInfo.queueStatus === BEQUEUE_CONFIG_STATE_RETRIED) {
    //     onQueueRetried()
    //   } else {
    //     set(pageState, prev => ({ ...prev, showSegmentationMessage: true }))
    //   }
    // }

    // const remainingSendings = SendLimit - TotalSend - TotalQueued

    // if (TrialRecepientLimit > 0 && remainingSendings <= 1) {
    //   onTrialRecipientLimit(remainingSendings)
    // }

    set(pageState, prev => ({ ...prev, showLoader: false, loadedStep2: true }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'AbTestWizard',
      Method: 'initSendingWizardCallback',
      Message: 'Errore in ottieni i dettagli del messaggio'
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger',
      showLoader: false,
      loadedStep2: true
    }))
  }
}

export const addNewTagCallback = ({ set, snapshot }) => async pTagName => {
  const { step1 } = await snapshot.getPromise(abTestState)

  try {
    const newTag = await addNewTag(pTagName)
    const tagsList = await getAllTags()

    set(tagsListState, prev => ({ ...prev, tagsList: tagsList.Items }))

    set(abTestState, prev => ({
      ...prev,
      step1: {
        ...prev.step1,
        tags: [...step1.tags, newTag.Id],
        step1IsDirty: true
      }
    }))
  } catch (error) {
    logAppError({
      Component: 'ABTestWizard',
      Method: 'addNewTagCallback',
      appError: error
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const getEmailSelectedMessageCallback = ({ snapshot, set }) => async (
  itemEmail,
  abTestMessages,
  droppableId
) => {
  const { step1 } = await snapshot.getPromise(abTestState)

  set(modalEmailMessagesState, prev => ({
    ...prev,
    selectedItem: itemEmail
  }))
  let ret = itemEmail
  const emailEntities = await fetchEmailEntitiesThatUseMessage(itemEmail.Id)
  // controllare l'uso in pagina negli items

  const isAlreadyUsedInPage = abTestMessages.find(e => e.Id === itemEmail.Id)

  let entityName = ''
  let entityType = ''
  let found = false
  if (emailEntities && emailEntities.length > 0) {
    emailEntities.forEach(element => {
      if (
        !found &&
        (element.Type === ENTITY_TYPE_AUTOMATION_WORKFLOW ||
          element.Type === ENTITY_TYPE_TRIGGER) &&
        element.Id !== itemEmail.Id
      ) {
        entityName = element.Name
        entityType = element.Type
        found = true
      }
    })
  }

  if (found || isAlreadyUsedInPage) {
    // usato
    set(modalUsedMessageState, prev => ({
      ...prev,
      show: true,
      entityName: isAlreadyUsedInPage ? step1.name : entityName,
      entityType: isAlreadyUsedInPage ? 'AutomationWorkflow' : entityType,
      // type: WORKFLOW_MESSAGE_TYPE_EMAIL,
      droppableId // usato per la riapertura della modale
    }))
    ret = undefined
  }

  set(modalEmailMessagesState, prev => ({
    ...prev,
    show: false
  }))
  return ret
}

export const putBeListSenderInfoCallback = ({ set, snapshot }) => async () => {
  set(pageState, prev => ({ ...prev, showLoader: true }))
  const { step2 } = await snapshot.getPromise(abTestState)
  const data = {
    SenderName: step2.senderInfo.senderName,
    SenderEmail: step2.senderInfo.senderEmail,
    SenderReplyTo: step2.senderInfo.replyToEmail
  }
  try {
    const { Result } = await putBeListSenderInfo(data)
    if (Result) {
      toastShow(
        getIntl().formatMessage({ id: 'Load.Alerts.SuccessUpdate' }),
        TOAST_VARIANT_SUCCESS,
        'saveSenderInfoSuccess'
      )
    } else {
      toastShow(
        getIntl().formatMessage({ id: 'Load.EmailCheckUp.ToastSaveError' }),
        TOAST_VARIANT_WARNING,
        'saveSenderInfoError'
      )
    }
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'AbtestWizard',
      Method: 'saveSenderFields',
      Message: 'Errore in ottieni i campi dinamici'
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
    toastShow(
      getIntl().formatMessage({ id: 'Load.EmailCheckUp.ToastSaveError' }),
      TOAST_VARIANT_WARNING,
      'saveSenderInfoError'
    )
  }

  set(pageState, prev => ({ ...prev, showLoader: false }))
}

export const initSearchCriteriaCallback = ({ set, snapshot }) => async () => {
  set(searchCriteriaState, prev => ({ ...prev, loading: true }))
  set(pageState, prev => ({ ...prev, showLoader: true, loadedStep3: false }))

  const { step2 } = await snapshot.getPromise(abTestState)

  try {
    const [groups, filters] = await Promise.all([
      getGroupsDetails(step2.recipients),
      getFilters()
    ])

    set(searchCriteriaState, prev => ({
      ...prev,
      groups,
      filters
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'AbTestWizard',
      Method: 'searchCriteriaCallback',
      Message: 'Errore in ottieni criteri di ricerca'
    })
    set(pageState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }

  set(searchCriteriaState, prev => ({ ...prev, loading: false, loaded: true }))
  set(pageState, prev => ({ ...prev, showLoader: false, loadedStep3: true }))
}

export const searchRecipientsAndSendingPreviewDataCallback = ({
  set,
  snapshot
}) => async () => {
  set(sendingPreviewState, prev => ({
    ...prev,
    previewLoading: true,
    showLoading: true
  }))
  try {
    await doRecipientsDataCallback(set, snapshot)
    await doSimulatePreviewFetch(set, snapshot)
  } catch (error) {
    logAppError({
      appError: error
    })
  }
  set(sendingPreviewState, prev => ({
    ...prev,
    previewLoading: false
  }))
}

async function doSimulatePreviewFetch(set, snapshot, idABTest) {
  set(sendingPreviewState, prev => ({
    ...prev,
    loading: true,
    loaded: false,
    error: undefined,
    severity: undefined,
    queued: undefined,
    excludedGroups: [],
    diff: undefined,
    showLoading: true
  }))

  const { id, step3 } = await snapshot.getPromise(abTestState)

  try {
    const [{ ToBeQueued }, { ToBeQueued: TotalItems }] = await Promise.all([
      simulatePreview(
        true,
        0, // idInvio
        id, // idAbtest
        step3.includeGroups,
        step3.excludeGroups,
        step3.selectedFilters,
        step3.typeAppliedFilters
      ),
      simulatePreview(false, 0)
    ])

    const diff = ToBeQueued

    set(sendingPreviewState, prev => ({
      ...prev,
      toBeQueued: ToBeQueued,
      diff,
      totalRecipients: TotalItems,
      oldIncludeGroups: step3.includeGroups,
      oldExcludeGroups: step3.excludeGroups,
      oldSelectedFilters: step3.selectedFilters
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'AbTestWizardSendingPreviewState',
      Method: 'sendingPreviewState',
      Message: 'Errore in simulazione da step wizard'
    })

    set(sendingPreviewState, prev => ({
      ...prev,
      loading: false,
      loaded: true,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  set(sendingPreviewState, prev => ({
    ...prev,
    showLoading: false,
    loading: false,
    loaded: true
  }))
}

async function doRecipientsDataCallback(set, snapshot) {
  const { step3 } = await snapshot.getPromise(abTestState)
  const recipientsDataTable = await snapshot.getPromise(
    recipientsDataTablePreviewState
  )
  set(recipientsDataTablePreviewState, prev => ({
    ...prev,
    loading: true,
    loaded: false
  }))
  try {
    const res = await searchForRecipients(step3, recipientsDataTable)

    set(recipientsDataTablePreviewState, prev => ({
      ...prev,
      loading: false,
      loaded: true,
      firstChange: false,
      items: res.Items
    }))
  } catch (error) {
    logAppError({
      appError: error
    })
    step3.selectedFilters.length > 0 &&
      toastShow(
        getIntl().formatMessage({
          id: 'Load.Alerts.GenericErrorApplyFiltersNew'
        }),
        TOAST_VARIANT_ERROR
      )
  }
  set(recipientsDataTablePreviewState, prev => ({
    ...prev,
    loading: false,
    loaded: true
  }))
}

export const setTestGroupCallback = ({ set, snapshot }) => async () => {
  const { groups } = await snapshot.getPromise(searchCriteriaState)
  const { step2, step3 } = await snapshot.getPromise(abTestState)

  if (groups.length > 0 && step3.includeGroups.length === 0) {
    set(abTestState, prev => ({
      ...prev,
      step3: {
        ...prev.step3,
        includeGroups: [step2.idTestDefault]
      }
    }))
  }
}

export const sendingPreviewCallback = ({ snapshot, set }) => async () => {
  await doSimulatePreviewFetch(set, snapshot)
}

export const searchRecipientsDataCallback = ({ snapshot, set }) => async () => {
  set(sendingPreviewState, prev => ({
    ...prev,
    showLoading: true
  }))
  await doRecipientsDataCallback(set, snapshot)
  set(sendingPreviewState, prev => ({
    ...prev,
    showLoading: false
  }))
}

export const modalColumnsManagementConfirmCallback = ({
  set
}) => async value => {
  try {
    await updateUserColumns({ Columns: value })
  } catch (error) {
    logAppError({
      appError: error
    })
    toastShow(
      getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      TOAST_VARIANT_ERROR
    )
  }
  set(visibleColumnsState, value)
  set(modalColumnsManagementState, { show: false })
}

export const startQueueAndGoToStep4Callback = ({
  set,
  snapshot
}) => async idABTest => {
  set(sendingPreviewState, prev => ({
    ...prev,
    showLoading: true
  }))
  const { step3, step2 } = await snapshot.getPromise(abTestState)

  try {
    await notifyQueueing(step2.senderEmail)

    const asyncGroupList = []

    step3.includeGroups.map(IdGroup =>
      asyncGroupList.push({
        IdGroup,
        Action: 0
      })
    )

    step3.excludeGroups.map(IdGroup =>
      asyncGroupList.push({
        IdGroup,
        Action: 1
      })
    )

    const data = {
      MailingDataInfo: {
        SenderName: step2.senderInfo.senderName,
        SenderEmail: step2.senderInfo.senderEmail,
        ReplyToEmail: step2.senderInfo.replyToEmail,
        CustomSender: step2.senderInfo.customSender,
        IdFieldSenderName: step2.senderInfo.customNameValue || 0,
        IdFieldSenderEmail: step2.senderInfo.customEmailValue || 0
      },
      QueueConfiguration: {
        IdList: parseInt(storeGet(STORE_KEY_ID_LIST)),
        IdInvio: 0,
        Action: 0,
        Type: 1,
        FiltersConditionRule:
          step3.typeAppliedFilters === MATCH_FILTER_CONDITION_ALL
            ? BEQUEUE_CONFIG_FILTER_COND_AND_NUM
            : BEQUEUE_CONFIG_FILTER_COND_OR_NUM,
        AsyncQueueFilterList: step3.selectedFilters.map(IdFilter => ({
          IdFilter
        })),
        AsyncQueueGroupList: asyncGroupList

        // AsyncQueueManualRecipientList: [
        //   {
        //     IdRecipient: 0
        //   }
        // ]
      }
    }

    const resp = await startProcessAbTestAction(idABTest, data)

    set(abTestState, prev => ({
      ...prev,
      step4: {
        ...prev.step4,
        idAsyncQueueConfig: resp.IdAsyncQueueConfiguration
      }
    }))
    set(pageState, prev => ({
      ...prev,
      wizardStep: 4,
      numberOfStepEnabled: 4
    }))
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'abTestWizard',
      Method: 'startQueueing',
      Message: "Errore durante l'accodamento dei messaggi"
    })
    set(progressState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
    toastShow(
      getIntl().formatMessage({
        id: 'Load.EmailSendingWizard.labelErrorMaster'
      }),
      TOAST_VARIANT_ERROR,
      'startQueueInfoFailed',
      false,
      true
    )
  }
  set(sendingPreviewState, prev => ({
    ...prev,
    showLoading: false
  }))
}

// export const checkProgressCallback = ({ set, snapshot }) => async () => {
//   const { step4, step1 } = await snapshot.getPromise(abTestState)

//   try {
//     const {
//       State,
//       Queued: queued,
//       ToBeQueued: toBeQueued,
//       Skipped
//     } = await getQueueConfiguration(step4.idAsyncQueueConfig)
//     let queuedPercentage = 0
//     let queueStatus
//     let variant = PROGRESSBAR_VARIANT_DEFAULT
//     let progressNumber = 0
//     let totPB = 0

//     if (
//       State === BEQUEUE_CONFIG_STATE_RUNNING ||
//       State === BEQUEUE_CONFIG_STATE_UPDATING ||
//       State === BEQUEUE_CONFIG_STATE_TOEXECUTE ||
//       State === BEQUEUE_CONFIG_STATE_COMPLETED
//     ) {
//       queueStatus =
//         State !== BEQUEUE_CONFIG_STATE_COMPLETED
//           ? BEQUEUE_CONFIG_STATE_RUNNING
//           : BEQUEUE_CONFIG_STATE_COMPLETED
//       if (toBeQueued) {
//         totPB = Math.ceil(toBeQueued * ((100 + step1.percTest) / 100))
//         queuedPercentage = Math.floor(((queued + Skipped) / totPB) * 100)
//         progressNumber = queued + Skipped
//       } else {
//         queuedPercentage = 0
//       }
//       variant = PROGRESSBAR_VARIANT_DEFAULT
//     }

//     if (
//       State === BEQUEUE_CONFIG_STATE_FAILED ||
//       State === BEQUEUE_CONFIG_STATE_RETRIED ||
//       State === BEQUEUE_CONFIG_STATE_CANCELLED ||
//       State === BEQUEUE_CONFIG_STATE_DISCARDED
//     ) {
//       queueStatus = BEQUEUE_CONFIG_STATE_FAILED
//       queuedPercentage = 100
//       variant = PROGRESSBAR_VARIANT_ERROR
//     }

//     set(abTestState, prev => ({
//       ...prev,
//       step4: {
//         ...prev.step4,
//         queueStatus,
//         queued,
//         toBeQueued,
//         queuedPercentage,
//         variant,
//         progressNumber,
//         totPB
//       }
//     }))
//   } catch (error) {
//     logAppError({
//       appError: error,
//       Component: 'abTestWizard',
//       Method: 'checkProgress',
//       Message: 'Errore in progresso accodamento da abtest wizard'
//     })
//     set(progressState, prev => ({
//       ...prev,
//       error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
//       severity: 'danger'
//     }))
//   }
// }

export const getAbTestGlobalStatusCallback = ({
  set,
  snapshot
}) => async () => {
  const { id } = await snapshot.getPromise(abTestState)

  try {
    const res = await getBeABTestGetGlobalStatus(id)

    const stop = res.OverallPercentage >= 100
    const variant = stop
      ? PROGRESSBAR_VARIANT_SUCCESS
      : PROGRESSBAR_VARIANT_DEFAULT
    const queueStatus = stop
      ? BEQUEUE_CONFIG_STATE_COMPLETED
      : BEQUEUE_CONFIG_STATE_RUNNING

    if (
      [ABTEST_STATUS_CONFIGURATION, ABTEST_STATUS_PRE_ENQUEUING].indexOf(
        res.Status
      ) >= 0
    ) {
      set(abTestState, prev => ({
        ...prev,
        stato: res.Status,
        step4: {
          ...prev.step4,
          status: res.Status,
          totalRecipients: res.TotalRecipients,
          overallPercentage: res.OverallPercentage,
          winningMessage: res.Queueings.find(f => f.MessageType === 'Winner'),
          abTestMessages: res.Queueings.filter(f => f.MessageType !== 'Winner'),
          queuedPercentage: 0,
          toBeQueued: res.TotalRecipients,
          variant,
          queueStatus,
          processGlobalStatus: !stop
        }
      }))
    } else if (
      [ABTEST_STATUS_ENQUEUING, ABTEST_STATUS_POST_ENQUEUING].indexOf(
        res.Status
      ) >= 0
    ) {
      set(abTestState, prev => ({
        ...prev,
        stato: res.Status,
        step4: {
          ...prev.step4,
          status: res.Status,
          totalRecipients: res.TotalRecipients,
          overallPercentage: res.OverallPercentage,
          winningMessage: res.Queueings.find(f => f.MessageType === 'Winner'),
          abTestMessages: res.Queueings.filter(f => f.MessageType !== 'Winner'),
          queuedPercentage: res.OverallPercentage,
          toBeQueued: res.TotalRecipients,
          variant,
          queueStatus,
          processGlobalStatus: !stop
        }
      }))
    } else if (
      [
        ABTEST_STATUS_SCHEDULING,
        ABTEST_STATUS_WAITING_FOR_SENDING_OF_TEST_MESSAGES
      ].indexOf(res.Status) >= 0
    ) {
      set(abTestState, prev => ({
        ...prev,
        stato: res.Status,
        step4: {
          ...prev.step4,
          status: res.Status,
          totalRecipients: res.TotalRecipients,
          overallPercentage: res.OverallPercentage,
          winningMessage: res.Queueings.find(f => f.MessageType === 'Winner'),
          abTestMessages: res.Queueings.filter(f => f.MessageType !== 'Winner'),
          queuedPercentage: res.OverallPercentage,
          toBeQueued: res.TotalRecipients,
          variant,
          queueStatus,
          processGlobalStatus: !stop
        }
      }))
    } else if (res.Status === ABTEST_STATUS_ERROR) {
      set(abTestState, prev => ({
        ...prev,
        stato: res.Status,
        step4: {
          ...prev.step4,
          processGlobalStatus: false,
          toBeQueued: '--',
          variant: PROGRESSBAR_VARIANT_ERROR,
          queueStatus: BEQUEUE_CONFIG_STATE_FAILED
        }
      }))
      toastShow(
        getIntl().formatMessage({ id: 'Load.EmailSendingWizard.QueueFailed' }),
        TOAST_VARIANT_ERROR,
        'QueueFailed'
      )
    } else {
      set(abTestState, prev => ({
        ...prev,
        stato: res.Status,
        step1: {
          ...prev.step1,
          step1IsDirty: false
        },
        step2: {
          ...prev.step2,
          step2IsDirty: false
        },
        step3: {
          ...prev.step3,
          step3IsDirty: false
        },
        step4: {
          ...prev.step4,
          step4IsDirty: false,
          changeHistory: '/messages/email/abtestlist'
        }
      }))
    }
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'abTestWizard',
      Method: 'getAbTestGlobalStatusCallback',
      Message: 'Errore in progress abtest wizard global status'
    })
    set(progressState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

const formatDate = (strDate, type = 1) => {
  if (strDate.indexOf('T') > -1) {
    const dateArray = strDate.split('T')
    const hmArray = dateArray[1].split(':')
    const date = dateArray[0]
    const h = hmArray[0]
    const m = hmArray[1]
    return type !== 0 ? `${date} ${h}:${m}` : `${date}`
  }
  return ''
}

const roundToClosestMultiple = (value, n = 1) => Math.round(value / n) * n
const roundToPreviousMultiple = (value, n = 1) => Math.floor(value / n) * n

export const checkScheduleAbTestByIdCallback = ({
  set,
  snapshot
}) => async () => {
  const { id: idABTest, step4 } = await snapshot.getPromise(abTestState)
  const { momentTimeZoneDate, timeZone } = await snapshot.getPromise(
    contentScheduledState
  )

  // const d = moment.tz(
  //   `${step4.dateModel.date} ${step4.dateModel.hour}:${step4.dateModel.minute}`,
  //   'YYYY-MM-DD HH:mm',
  //   zones[step4.dateModel.timeZoneCode]
  // )

  const dateCTZ = momentTimeZoneDate.format('YYYY-MM-DDTHH:mm:ss.SSSS[Z]')

  try {
    const res = await checkScheduleAbTestByIdAction(idABTest, timeZone, {
      ABTestMsgDateCTZ: dateCTZ,
      ABTestWinnerMsgDateInSeconds: step4.winnerScheduling * 3600
    })

    if (res.ABTestMsgDateCTZ) {
      const date = moment.tz(
        res.ABTestMsgDateUTC,
        zones[res.TimeZoneInternalCode]
      )
      const minutes = roundToPreviousMultiple(+date.format('mm'), 5)

      date.set('minutes', minutes)
      date.add(5, 'minutes')

      set(contentScheduledState, prev => ({
        ...prev,
        momentTimeZoneDate: date,
        momentUtcDate: date.clone().utc()
      }))
      set(abTestState, prev => ({
        ...prev,
        step4: {
          ...prev.step4,
          // dateModel: {
          //   ...prev.step4.dateModel,
          //   date: date.format('YYYY-MM-DD'),
          //   hour: +date.format('HH'),
          //   minute: +date.format('mm'),
          //   utcDate: res.ABTestMsgDateUTC
          // },
          winnerScheduling: res.ABTestWinnerMsgDateInSeconds
            ? Math.floor(res.ABTestWinnerMsgDateInSeconds / 3600)
            : step4.winnerScheduling,
          loaded: true
        }
      }))
    }
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'abTestWizard',
      Method: 'checkScheduleAbTestByIdAction',
      Message: 'Errore in check Schedule AbTest By Id'
    })
    set(progressState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
}

export const saveScheduleAbTestByIdCallback = ({
  set,
  snapshot
}) => async () => {
  const { id: idABTest, step4, step1 } = await snapshot.getPromise(abTestState)
  const { momentTimeZoneDate, timeZone } = await snapshot.getPromise(
    contentScheduledState
  )
  set(pageState, prev => ({ ...prev, loading: true }))

  // const d = moment.tz(
  //   `${step4.dateModel.date} ${step4.dateModel.hour}:${step4.dateModel.minute}`,
  //   'YYYY-MM-DD HH:mm',
  //   zones[step4.dateModel.timeZoneCode]
  // )
  // const dateCTZ = d
  //   .utc()
  //   .tz(zones[step4.dateModel.timeZoneCode])
  //   .format('YYYY-MM-DDTHH:mm:ss.SSSS[Z]')

  const dateCTZ = momentTimeZoneDate.format('YYYY-MM-DDTHH:mm:ss.SSSS[Z]')

  try {
    const res = await scheduleAbTestByIdAction(idABTest, timeZone, {
      ABTestMsgDateCTZ: dateCTZ,
      ABTestWinnerMsgDateInSeconds: step4.winnerScheduling * 3600
    })

    set(abTestState, prev => ({
      ...prev,
      stato: res.ABTestScheduledResult,
      step1: {
        ...prev.step1,
        step1IsDirty: false
      },
      step2: {
        ...prev.step2,
        step2IsDirty: false
      },
      step3: {
        ...prev.step3,
        step3IsDirty: false
      },
      step4: {
        ...prev.step4,
        step4IsDirty: false
      }
    }))

    if (res.ABTestScheduledResult === ABTEST_STATUS_SCHEDULED) {
      set(abTestState, prev => ({
        ...prev,
        step1: {
          ...prev.step1,
          step1IsDirty: false
        },
        step2: {
          ...prev.step2,
          step2IsDirty: false
        },
        step3: {
          ...prev.step3,
          step3IsDirty: false
        },
        step4: {
          ...prev.step4,
          step4IsDirty: false,
          changeHistory: '/messages/email/sendstatus/campaigns'
        }
      }))
    } else {
      if (
        res.ABTestScheduledResult === ABTEST_STATUS_SUGGESTED_TEST_DATE ||
        res.ABTestScheduledResult === ABTEST_STATUS_SUGGEST_BOTH_DATE
      ) {
        if (res.ABTestMsgDateCTZ) {
          const date = moment.tz(
            res.ABTestMsgDateUTC,
            zones[res.TimeZoneInternalCode]
          )
          const minutes = roundToPreviousMultiple(+date.format('mm'), 5)

          date.set('minutes', minutes)
          date.add(5, 'minutes')

          const tmp1 = getIntl().formatMessage({
            id: 'Load.ABTestingSchedule.WarningTestSchedulingFirstAvailable'
          })

          const tmp2 = ` ${date.format('YYYY-MM-DD HH:mm')}. `
          const tmp3 = getIntl().formatMessage({
            id: 'Load.ABTestingSchedule.WarningGenericSchedulingFirstAvailable'
          })
          toastShow(
            tmp1 + tmp2 + tmp3,
            TOAST_VARIANT_WARNING,
            'WarningTestSchedulingFirstAvailable'
          )

          set(contentScheduledState, prev => ({
            ...prev,
            momentTimeZoneDate: date,
            momentUtcDate: date.clone().utc()
          }))

          set(abTestState, prev => ({
            ...prev,
            step4: {
              ...prev.step4,
              // dateModel: {
              //   ...prev.step4.dateModel,
              //   date: date.format('YYYY-MM-DD'),
              //   hour: +date.format('HH'),
              //   minute: +date.format('mm'),
              //   utcDate: res.ABTestMsgDateUTC
              // },
              loaded: true
            }
          }))
        } else {
          // Il servizio non è riuscito a schedulare l'invio di test
          toastShow(
            getIntl().formatMessage({
              id: 'Load.ABTestingSchedule.WarningTestSchedulingNotAvailable'
            }),
            TOAST_VARIANT_ERROR,
            'WarningTestSchedulingNotAvailable'
          )
        }
      }
      if (
        res.ABTestScheduledResult === ABTEST_STATUS_SUGGESTED_WINNER_DATE ||
        res.ABTestScheduledResult === ABTEST_STATUS_SUGGEST_BOTH_DATE
      ) {
        if (step1.tipoTest === 'A') {
          if (res.ABTestWinnerMsgDateInSeconds) {
            const hours = Math.floor(res.ABTestWinnerMsgDateInSeconds / 3600)
            step1.winnerScheduling = hours

            const tmp1 = getIntl().formatMessage({
              id: 'Load.ABTestingSchedule.WarningWinnerSchedulingFirstAvailable'
            })
            const tmp2 = ` ${step1.winnerScheduling} `
            const tmp3 = getIntl().formatMessage({
              id: 'Load.ABTestingSchedule.SendWinnerAfterOnlyHours'
            })
            const tmp4 = ` ${getIntl().formatMessage({
              id:
                'Load.ABTestingSchedule.WarningGenericSchedulingFirstAvailable'
            })}`
            toastShow(
              tmp1 + tmp2 + tmp3 + tmp4,
              TOAST_VARIANT_WARNING,
              'WarningWinnerSchedulingFirstAvailable'
            )
          } else {
            // Il servizio non è riuscito a schedulare l'invio di test
            toastShow(
              getIntl().formatMessage({
                id: 'Load.ABTestingSchedule.WarningTestSchedulingNotAvailable'
              }),
              TOAST_VARIANT_WARNING,
              'WarningTestSchedulingNotAvailable'
            )
          }
        }
      }
    }
  } catch (error) {
    logAppError({
      appError: error,
      Component: 'abTestWizard',
      Method: 'saveScheduleAbTestByIdCallback',
      Message: 'Errore in Schedule AbTest By Id'
    })
    set(progressState, prev => ({
      ...prev,
      error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
      severity: 'danger'
    }))
  }
  set(pageState, prev => ({ ...prev, loading: false }))
}

export const errorCallback = ({ set }) => async error => {
  console.error('### error', error)
  logAppError({
    appError: error,
    Component: 'AbTestWizard',
    Method: 'errorCallback'
  })

  set(pageState, prev => ({
    ...prev,
    error: getIntl().formatMessage({ id: 'Load.Alerts.ErrorGeneric' }),
    severity: 'danger'
  }))
}
